import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4072900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 로그인 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/login_intro.png",
  srcset: "/assets/image/login_intro@2x.png 2x,/assets/image/login_intro@3x.png 3x"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, [
  /*#__PURE__*/_createTextVNode(" 엔젤리그의 모든 기능을 사용하고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 소중한 자산을 안전하게 관리할 수 있도록"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 로그인을 진행해주세요 ")
], -1))
const _hoisted_5 = { class: "form-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 이름 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 전화번호 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 생년월일 ")
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}
const _hoisted_10 = { class: "footer-btn-container" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left_top_logo = _resolveComponent("left-top-logo")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_left_top_logo),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ion_item, { class: "form-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    type: "text",
                    placeholder: "이름"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { class: "form-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.form.phone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
                    type: "tel",
                    placeholder: "010-0000-0000"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { class: "form-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.form.birthDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.birthDate) = $event)),
                    type: "date",
                    placeholder: "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { translucent: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "block_btn",
              disabled: !_ctx.isFormValid,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.lookupUuid && _ctx.lookupUuid(...args)))
            }, " 로그인 ", 8, _hoisted_11),
            _createElementVNode("div", {
              class: "forgot-link",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/forgot-simple-password')))
            }, " 비밀번호를 잊으셨나요? ")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}